module.exports = __webpack_public_path__ + "media/images/flags/4x3/ner-5a508910838400247ce45ac8f5a7b239.svg";